/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';

const LiveChatSpaceSvg = ({ color }) => (
  <svg width="1em" height="1em" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2736_2436" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="19">
      <path d="M21.6668 4.33301C21.6668 2.12387 19.876 0.333008 17.6668 0.333008H4.3335C2.12436 0.333008 0.333496 2.12387 0.333496 4.33301V10.9997C0.333496 13.2088 2.12436 14.9997 4.3335 14.9997H7.796C9.00705 14.9997 10.182 15.4118 11.1277 16.1684L14.1672 18.6C15.0403 19.2984 16.3335 18.6768 16.3335 17.5588V16.333C16.3335 15.5966 16.9305 14.9997 17.6668 14.9997C19.876 14.9997 21.6668 13.2088 21.6668 10.9997V4.33301Z" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2736_2436)">
      <rect x="17.8491" y="-7.87109" width="24.6033" height="8.20111" transform="rotate(64.2147 17.8491 -7.87109)" fill={color === 'primary' ? '#C44B25' : color === 'transparent' ? 'rgba(255, 255, 255, 0.5)' : 'currentColor'} />
      <rect x="9.63428" y="-6.06641" width="25.7348" height="8.20111" transform="rotate(64.2147 9.63428 -6.06641)" fill={color === 'primary' ? '#F97330' : color === 'transparent' ? 'rgba(255, 255, 255, 0.75)' : 'currentColor'} />
      <rect x="2.38428" y="-2.31934" width="24.6033" height="8.20111" transform="rotate(64.2147 2.38428 -2.31934)" fill={color === 'primary' ? '#FFA679' : color === 'transparent' ? '#FFFFFF' : 'currentColor'} />
    </g>
  </svg>
);

export const LiveChatSpaceIcon = props => {
  const { color, ...restProps } = props;
  return (
    <Icon
      component={() => <LiveChatSpaceSvg color={color} />}
      {...restProps}
    />
  );
};

LiveChatSpaceSvg.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};

LiveChatSpaceIcon.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};
